import { addDays, format } from 'date-fns';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { WeekNavCalendarPopover } from './WeekNavCalendarPopover';
import { VIEWING_OTHER_RESOURCE_TITLE, type WeekNavVariantProps } from './weekNavTypes';

/** Week selector layout used between 768px and 1023px. */
export function WeekNavTablet({
  currentWeekStart,
  status,
  isViewingOtherResource,
  minAllowedDate,
  maxAllowedDate,
  onNavigate,
  onNavigateToDate,
}: WeekNavVariantProps) {
  const disabledTitle = isViewingOtherResource ? VIEWING_OTHER_RESOURCE_TITLE : undefined;

  return (
    <div className="flex items-center gap-2" data-tour="timesheet-week-nav">
      <Button
        variant="outline"
        size="icon"
        className="h-9 w-9"
        onClick={() => onNavigate('prev')}
        disabled={isViewingOtherResource}
        title={disabledTitle}
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <div className="flex items-center gap-2 min-w-[240px]">
        <h2 className="text-sm font-semibold">
          Week: {format(currentWeekStart, 'dd MMM')} - {format(addDays(currentWeekStart, 6), 'dd MMM yyyy')}
        </h2>
        <WeekNavCalendarPopover
          currentWeekStart={currentWeekStart}
          minAllowedDate={minAllowedDate}
          maxAllowedDate={maxAllowedDate}
          isViewingOtherResource={isViewingOtherResource}
          onNavigateToDate={onNavigateToDate}
        />
        <Badge
          variant={
            status === 'draft' ? 'secondary' :
            status === 'submitted' ? 'default' :
            status === 'approved' ? 'default' :
            'secondary'
          }
          className="text-xs w-[90px] justify-center"
          data-tour="timesheet-status"
        >
          {status.toUpperCase()}
        </Badge>
      </div>
      <Button
        variant="outline"
        size="icon"
        className="h-9 w-9"
        onClick={() => onNavigate('next')}
        disabled={isViewingOtherResource}
        title={disabledTitle}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
